

















































import Vue from "vue";
import ImageDialog from "../Utilities/ImageDialog.vue";
import {
  ImageButton,
  bridgeImages,
  roadwayImages,
  publicMeetingImages
} from "./imageList";

export default Vue.extend({
  name: "ImageGalleryViewer",
  data() {
    return {
      opened: [0, 1, 2],
      listOfTopics: ["Bridge", "Roadways", "Public Meetings"],
      showDialog: false,
      dialogDetails: { overlay: false, opacity: 0 },
      bridgeImages: bridgeImages,
      roadwayImages: roadwayImages,
      publicMeetingImages: publicMeetingImages
    };
  },
  components: {
    ImageDialog
  },
  computed: {
    btnWidth() {
      if (this.$vuetify.breakpoint.xs) return `100%`;
      else return `90%`;
    }
  },
  methods: {
    hideDialog() {
      this.showDialog = false;
      this.dialogDetails = { overlay: false, opacity: 0 };
    },
    openDialog(pic: ImageButton) {
      this.showDialog = true;
      this.dialogDetails = pic;
    },
    images(section: string) {
      if (section === "Bridge") return bridgeImages;
      if (section === "Roadways") return roadwayImages;
      if (section === "Public Meetings") return publicMeetingImages;
    },
    getImage(image: string) {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const reqImage = require(`../../../public/static/ImageGallery/${image}`);
      return `url(${reqImage})`;
    }
  }
});
